import ActionTypes from "../constants/action_types";

export default function clearWorkflows() {
  return {
    type: ActionTypes.WORKFLOWS_CLEAR.SUCCESS,
  };
}
